import { EntityConfig } from "./EntityConfig";
var ClassFieldReader = (function () {
    function ClassFieldReader(konstructor) {
        this.konstructor = konstructor;
    }
    ClassFieldReader.prototype.all = function () {
        var fields = this.config.getFields();
        return fields.map(function (f) {
            var _a, _b, _c;
            return {
                name: f.name,
                fieldArrayLike: f.isArrayLike(),
                entityConstructor: (_a = f.entity) !== null && _a !== void 0 ? _a : f.reflectedEntity,
                nullable: f.nullable,
                subFields: isHasFieldsIntrospection(f.entity)
                    ? (_c = (_b = f.entity) === null || _b === void 0 ? void 0 : _b.fields()) === null || _c === void 0 ? void 0 : _c.all()
                    : undefined
            };
        });
    };
    Object.defineProperty(ClassFieldReader.prototype, "config", {
        get: function () {
            return EntityConfig.forConstructor(this.konstructor);
        },
        enumerable: false,
        configurable: true
    });
    return ClassFieldReader;
}());
export { ClassFieldReader };
var EntityFieldReader = (function () {
    function EntityFieldReader(instance) {
        this.instance = instance;
    }
    EntityFieldReader.prototype.onlySet = function () {
        var _this = this;
        return this.parentFields.filter(function (field) {
            var fieldValue = _this.instance[field.name];
            if (field.nullable === true && fieldValue === null) {
                return true;
            }
            return fieldValue != null;
        });
    };
    EntityFieldReader.prototype.onlyUnset = function () {
        var _this = this;
        return this.parentFields.filter(function (field) {
            var fieldValue = _this.instance[field.name];
            return fieldValue == null;
        });
    };
    EntityFieldReader.prototype.all = function () {
        return this.parentFields;
    };
    Object.defineProperty(EntityFieldReader.prototype, "parentFields", {
        get: function () {
            return new ClassFieldReader(this.instance.constructor).all();
        },
        enumerable: false,
        configurable: true
    });
    return EntityFieldReader;
}());
export { EntityFieldReader };
function isHasFieldsIntrospection(maybeEntity) {
    var _a;
    return typeof ((_a = maybeEntity) === null || _a === void 0 ? void 0 : _a.fields) === "function";
}
